/**
 * Strips all whitespace from input (used for username/password fields)
 */
export const removeSpaces = (value?: string): string => (value ? value.replace(/\s/g, '') : '');
